import apiClient, { ApiResponse } from './api'

export interface ActivityLog {
    _id: string
    createdAt: string
    createdBy: string | null
    updatedAt: string
    updatedBy: string | null
    deletedAt: string | null
    deletedBy: string | null
    userId: string
    userEmail: string
    tenantId?: string | null
    userRoles: string[]
    serviceName: string
    moduleName: string
    actionType: string
    entityType: string
    entityId: string
    metadata?: Record<string, any>
    requestMetadata?: {
        ip?: string
        userAgent?: string
        method?: string
        path?: string
    }
    __v: number
}

export interface ActivityLogFilters {
    email?: string
    tenantId?: string
    actionType?: string
    entityType?: string
    entityId?: string
    startDate?: string
    endDate?: string
    page?: number
    limit?: number
}

export interface ActivityLogResponse {
    success: boolean
    data: ActivityLog[]
    pagination: {
        page: number
        limit: number
        total: number
        totalPages: number
    }
}

class ActivityLogsApi {
    /**
     * Fetch activity logs with optional filters and pagination
     */
    async getActivityLogs(
        filters: ActivityLogFilters = {}
    ): Promise<ApiResponse<ActivityLogResponse>> {
        const params = new URLSearchParams()

        // Add pagination params
        if (filters.page) params.append('page', filters.page.toString())
        if (filters.limit) params.append('limit', filters.limit.toString())

        // Add filter params
        if (filters.email) params.append('email', filters.email)
        if (filters.tenantId) params.append('tenantId', filters.tenantId)
        if (filters.actionType) params.append('actionType', filters.actionType)
        if (filters.entityType) params.append('entityType', filters.entityType)
        if (filters.entityId) params.append('entityId', filters.entityId)
        if (filters.startDate) params.append('startDate', filters.startDate)
        if (filters.endDate) params.append('endDate', filters.endDate)

        const queryString = params.toString()
        const endpoint = `/auth-service/api/v1/activity-logs${queryString ? `?${queryString}` : ''}`

        return apiClient.get<ActivityLogResponse>(endpoint)
    }
}

export const activityLogsApi = new ActivityLogsApi()
export default activityLogsApi
